import {
  faPlus,
  faCopy,
  faTrashAlt,
  faPencil,
  faExternalLink,
} from '@fortawesome/pro-regular-svg-icons';

import * as React from 'react';

const buildActions = (handlers, props) => [
  {
    tooltip: 'New',
    icon: 'add_circle_outline',
    isFreeAction: true,
    onClick: () => handlers.new(props),
    toobarHide: () => !handlers.new,
    toolbarIcon: faPlus,
    toolbarClassName: 'btn-create',
    toolbarButtonPriority: 'primary',
  },
  () => {
    const {
      api: { copy },
    } = props;

    if (handlers.copy && (copy || handlers.supportsCopy)) {
      return {
        tooltip: 'Duplicate',
        icon: faCopy,
        isRowAction: true,
        onClick: (_, item) => handlers.copy(item, props),
      };
    }

    return null;
  },
  {
    tooltip: 'Edit',
    icon: faPencil,
    isRowAction: true,
    onClick: (_, item) => handlers.edit(item, props),
  },
  () => {
    if (handlers.delete && handlers.supportsDelete) {
      return {
        tooltip: 'Delete',
        icon: faTrashAlt,
        isSelectedAction: true,
        onClick: (_, item) =>
          handlers.delete(Array.isArray(item) ? [...item] : item, props),
        toolbarIcon: faTrashAlt,
        toolbarClassName: 'btn-delete',
        toolbarButtonPriority: 'danger',
        modal: true,
        modalStyle: 'danger',
        modalConfirmButtonText: 'Yes, delete',
        modalMessage: (
          <div className="font-weight-bold" style={{ fontSize: '16px' }}>
            The following titles will be{' '}
            <span className="text-danger">deleted</span>
          </div>
        ),
      };
    }

    return null;
  },
  () => {
    if (handlers.publish) {
      return {
        tooltip: 'Publish',
        icon: faPencil,
        isSelectedAction: true,
        onClick: (_, item) =>
          handlers.publish(Array.isArray(item) ? [...item] : item, props),
        toolbarIcon: faPencil,
        toolbarClassName: 'btn-primary',
        toolbarButtonPriority: 'primary',
        modal: true,
        modalStyle: 'primary',
        modalConfirmButtonText: 'Yes, publish',
        modalMessage: (
          <div className="font-weight-bold" style={{ fontSize: '16px' }}>
            The following titles will be{' '}
            <span className="text-success">published</span>
          </div>
        ),
      };
    }

    return null;
  },
  data => {
    if (
      !data ||
      (!data.url && !(handlers.showOpenUrl && handlers.showOpenUrl(data))) ||
      !handlers.openExternal
    )
      return null;

    return {
      tooltip: 'View Online',
      icon: faExternalLink,
      isRowAction: true,
      onClick: (_, item) => handlers.openExternal(item, props),
    };
  },
];

export default (handlers, props) =>
  buildActions(
    {
      openExternal: item => {
        window.open(item.url);
        document.activeElement.blur();
      },
      ...handlers,
    },
    props
  );
